/**
 * @module web/util/password-validation
 * @description Shared password-strength validation. Was defined identically
 * (same conditions, same message) in create-class-overlay.tsx and
 * new-password-required.tsx before being consolidated here.
 */

const PASSWORD_REQUIREMENTS_MESSAGE =
	'The password must be at least 8 characters long and must use a lower case character, an upper case character, a number, and a special character.'

const PASSWORD_CONDITIONS: RegExp[] = [
	/.{8,}/,
	/[0-9]+/,
	/[a-z]+/,
	/[A-Z]+/,
	/[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=]+/,
]

export const isPasswordValid = (password: string): boolean =>
	PASSWORD_CONDITIONS.every(pattern => password.match(pattern))

/**
 * Sets (or clears) an input's native validity message based on password
 * strength, for use in an onBlur handler.
 *
 * @param target - The password input element
 */
export const validatePasswordField = (target: HTMLInputElement): void => {
	target.setCustomValidity(isPasswordValid(target.value) ? '' : PASSWORD_REQUIREMENTS_MESSAGE)
}
